import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRumInstance } from '../rum';

/**
 * Hook to track page views in RUM following Amazon best practices
 * Automatically tracks route changes and includes page context
 */
export const useRumPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const addRumContext = async () => {
      const rum = await getRumInstance();
      if (rum) {
        rum.recordPageView({
          pageId: location.pathname,
          pageAttributes: {
            path: location.pathname,
            search: location.search,
            hash: location.hash,
          },
        });
      }
    };

    addRumContext();
  }, [location]);
};
